import React, { useState } from 'react';
import Modal from './Modal';
import { api } from '../../lib/api';

// VoidInvoiceDialog — Sprint E item 4.12. Modal asking for void_reason.
// Locks invoice on submit; caller refreshes and re-renders detail.

export default function VoidInvoiceDialog({ open, invoiceId, onClose, onVoided }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    setError('');
    if (reason.trim().length < 10) { setError('Reason must be at least 10 characters'); return; }
    setSubmitting(true);
    try {
      const r = await api.post(`/api/admin/financial/invoices/${invoiceId}/void`, { reason: reason.trim() });
      onVoided?.(r.invoice);
      setReason('');
      onClose?.();
    } catch (err) {
      setError(err?.data?.error || err?.message || 'Failed to void invoice');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={submitting ? () => {} : onClose}
      title="Void invoice"
      footer={
        <div className="flex items-center justify-end gap-3 w-full">
          <button type="button" onClick={onClose} disabled={submitting}
            className="px-4 py-2.5 rounded-full border border-white/[0.1] text-sm text-gray-300 hover:text-white">
            Cancel
          </button>
          <button type="button" data-testid="void-invoice-confirm" onClick={submit} disabled={submitting}
            className="px-5 py-2.5 rounded-full bg-red-500 text-white text-sm font-semibold hover:bg-red-600 disabled:opacity-50">
            {submitting ? 'Voiding…' : 'Confirm void'}
          </button>
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-[13px] text-gray-300">
          Voiding the invoice locks it against further edits and marks it for the audit trail. You can issue a replacement afterward.
        </p>
        <label className="block">
          <span className="block text-[11px] uppercase tracking-wider text-gray-400/80 mb-1.5">Void reason *</span>
          <textarea
            data-testid="void-invoice-reason"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Required (≥10 chars). Captured into the audit trail."
            className="w-full px-3 py-2 rounded-lg bg-white/[0.04] border border-white/[0.08] text-sm text-white"
          />
        </label>
        {error && (
          <div className="px-3 py-2 rounded-lg bg-red-500/[0.08] border border-red-500/20 text-[13px] text-red-300/90">
            {error}
          </div>
        )}
      </div>
    </Modal>
  );
}
